/**
 * Tipos de domínio do módulo Leagues (Ligas).
 * "Liga" é o termo de produto para o que a arquitetura chama de `groups`
 * no Firestore — mantemos o nome de coleção (compatibilidade com o schema
 * já desenhado), mas a UI e o domínio falam sempre "Liga".
 */

export type LeagueRole = "admin" | "moderator" | "member";

export type LeagueStatus = "aberta" | "em_andamento" | "encerrada";

/** Temporada atual do sistema — NUNCA hardcoded (ver Parte 17/3 do escopo de integração real). */
export function getCurrentSeason(): number {
  return new Date().getFullYear();
}

export interface LeagueSummary {
  id: string;
  nome: string;
  competitionId: string;
  /** Código da competição na Football Data API (ex: "BSA", "CL") — usado nas chamadas reais de partidas/clubes. Hoje tem o mesmo valor de `competitionId`; campo mantido separado por clareza semântica (ver escopo "verificação da cadeia Liga → competição → temporada"). */
  competitionCode: string;
  competitionName: string;
  /** Temporada/ano da competição (ex: 2026) — sempre `getCurrentSeason()` no momento da criação. */
  season: number;
  bannerUrl: string | null;
  participantsCount: number;
  status: LeagueStatus;
  currentRoundLabel: string;
  /** Partidas da rodada atual que o usuário logado ainda não palpitou. */
  pendingPredictionsCount: number;
  hasLiveMatch: boolean;
  inviteCode: string;
  myRole: LeagueRole;
  createdAt: string; // ISO date
}

export interface ScoringRule {
  id: string;
  label: string;
  points: number;
}

export interface LeagueRules {
  frozenAt: string | null;
  rules: ScoringRule[];
}

export interface LeagueDetail extends LeagueSummary {
  descricao: string | null;
  maxParticipantes: number;
  privada: boolean;
  permiteDesafios: boolean;
  permitePerguntasBonus: boolean;
  permiteImportacaoManual: boolean;
  permiteEntradaAposInicio: boolean;
  disabledClubIds: string[];
  rules: LeagueRules;
}
